import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the login state domain
 */

const selectLoginDomain = state => state.login || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by Login
 */

const makeSelectLogin = () =>
  createSelector(
    selectLoginDomain,
    substate => substate,
  );

const makeSelectUser = () =>
  createSelector(
    selectLoginDomain,
    substate => substate.currentUser,
  );

const makeSelectUserLoading = () =>
  createSelector(
    selectLoginDomain,
    substate => substate.loading,
  );

const makeSelectUserError = () =>
  createSelector(
    selectLoginDomain,
    substate => substate.error,
  );

const makeSelectLoginForm = () =>
  createSelector(
    selectLoginDomain,
    substate => substate.loginValues,
  );

const makeSelectAuthenticated = () =>
  createSelector(
    selectLoginDomain,
  substate => substate.authenticated,
  // (substate) => {
  //   if(substate) {
  //     return substate.authenticated;
  //   } else {
  //     let item = localStorage.getItem("token");
  //     if(item){
  //       return true;
  //     } else {
  //       return false;
  //     }
  //   }
  // }
);

// export default makeSelectLogin;
export {
  selectLoginDomain,
  makeSelectLogin,
  makeSelectUser,
  makeSelectUserLoading,
  makeSelectUserError,
  makeSelectLoginForm,
  makeSelectAuthenticated,
};
